module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "CC-H"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/illust_maps"
    }
  }, [_vm._v("List of Illustrations and Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/map#map"
    }
  }, [_vm._v("Map of England, France and Brittany during the Wars of the Roses")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/familytree#family"
    }
  }, [_vm._v("Family Trees")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm1#fm1"
    }
  }, [_vm._v("A Note on Money and Dates")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#prol"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "CC-P"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PART ONE: BEGINNINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("1. Fortune’s Wheel")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("2. To Conquer or Die")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Exile")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "CC-P"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PART TWO: ASCENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Usurpation")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Rebellion")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Rat, the Cat and the Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. A Confederacy of Rebels")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Spiral of Decline")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "CC-P"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PART THREE: ‘THIS OUR ENTERPRISE’")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. March to War")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Secret Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "CC-P"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PART FOUR: AFTERMATH")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Our Victorious Field")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Reward, Retribution and Reconciliation")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Bosworth Rediscovered")])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/postscript#post",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX1"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/note#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix#app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliographic Essay")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo1#ph1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adcard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Chris Skidmore")])])]), _vm._v(" "), _c('p', {
    staticClass: "CC-TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0